import { connect } from 'react-redux';

import Updates from '../../../components/Modal/Updates';

export default connect()(Updates);
